import React from "react";
import { PORTFOLIO } from "../data/content";
import { SectionHeader, Reveal } from "./Ornament";

export default function Portfolio() {
  return (
    <section
      id="portfolio"
      className="relative bg-[var(--lu-black)] section-y grain"
      data-testid="portfolio-section"
    >
      <div className="container-lux">
        <SectionHeader
          kicker="The Archive"
          title="Portfolio"
          italicTitle="from moments"
          sub="A selection of nights we've turned into legends — from private villas to grand ballrooms in Europe and the Mediterranean."
          light
        />

        <div className="mt-24 grid grid-cols-2 md:grid-cols-4 auto-rows-[240px] md:auto-rows-[280px] gap-5">
          {PORTFOLIO.map((p, i) => (
            <Reveal delay={Math.min((i % 6) + 1, 6)} key={i}>
              <div
                className={`tile ${p.span} h-full`}
                data-testid={`portfolio-tile-${i}`}
              >
                <img src={p.src} alt={p.label} className="w-full h-full object-cover" />
                <div className="tile-cover-overlay" />
                <div className="tile-caption">
                  <p className="kicker">Signature</p>
                  <p className="mt-2 font-serif text-[22px] text-[var(--lu-ivory)]">{p.label}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
